
/* global multisite */

export async function fetchPosts(){
	return (fetch(multisite.api_url+`wp-json/wp/v2/posts/?consumer_key=${multisite.keys.key}&consumer_secret=${multisite.keys.secret}&_embed&_fields`, {
		method: "GET",
		headers: { "Content-Type": "application/json" },
	})
		.then((res) => res.json()));
}

export async function fetchTag(){
	return (fetch(multisite.api_url+"wp-json/wp/v2/tags", {
		method: "GET",
		headers: { "Content-Type": "application/json" },
	})
		.then((res) => res.json()));
}

export async function fetchSOLR(search, shard = 'flower', type = 'blogSearchResults', settings = null){
	let url = "https://wikannabis.com/wp-content/plugins/WikannabisHeart/solr_api_v2.php?search="+search+"&shard="+shard+"&type="+type;

	console.log({settings})
	if (settings != null && settings.length > 0){
		settings.map(x => {
			url += `&${x.key}=${x.value}`;
		});
	}
	return (fetch(url, {
		method: "GET",
		headers: { "Content-Type": "application/json" },
	})
		.then((res) => res.json()));
}